import { IAppState } from '../common/state';

export function selectChat(state: IAppState) {
  return state.chat;
}
